const doc = [({"en":({"js":({"admin":({"layout":({"top_menu":({"extended_search":({"group":({"and_label":"And", "or_label":"Or"})})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;